export default __webpack_public_path__ + "static/media/image_alt.2bd2361c.svg";